import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function ImagineSection() {
  return <section className="py-20 bg-[#F0F7F4]" data-id="element-150">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-152">
          <div className="inline-flex items-center gap-2 bg-[#081C15]/10 text-[#081C15] px-4 py-2 rounded-full text-sm font-medium mb-4" data-id="element-153">
            <SparklesIcon className="w-4 h-4" data-id="element-154" />
            Real Results
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#081C15] mb-4" data-id="element-155">
            Imagine Your Yard Like This
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-156">
            See the difference professional landscaping makes. This is what
            happens when you trust I&A Landscaping with your outdoor space.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-157">
          <img src="https://cdn.magicpatterns.com/uploads/gC9GnCVZgNrP17axPDa2cH/IA6.png" alt="Before and after landscaping transformation by I&A Landscaping — overgrown yard transformed into a beautifully designed front garden with sculpted bushes and decorative stone" className="w-full h-auto object-cover" data-id="element-158" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="text-center text-sm text-gray-500 mt-4" data-id="element-159">
          Actual project completed by I&A Landscaping in Northeast Ohio
        </motion.p>
      </div>
    </section>;
}